import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';


@Component({
    selector: 'app-player-ranking-list-entry',
    imports: [MatIconModule],
    templateUrl: './player-ranking-list-entry.component.html',
    styleUrls: ['./player-ranking-list-entry.component.css']
})
export class PlayerRankingListEntryComponent implements OnInit {

  @Input() List: any;
  constructor() { }

  ngOnInit() {
  }

  

}
